import {
  B_10,
  BANNER_DEFAULTS,
  hideB10Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B10_PLASMIC_PROPS = {
  b10Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_10].heading,
    description: "Main heading (B10 only)",
    hidden: hideB10Props,
  },
  b10Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_10].description,
    description: "Description text (B10 only)",
    hidden: hideB10Props,
  },
  b10ButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_10].buttonText,
    description: "Button text (B10 only)",
    hidden: hideB10Props,
  },
  b10ButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Button link type (B10 only)",
    hidden: hideB10Props,
  },
  b10ButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open button in new tab (B10 only)",
    hidden: hideB10Props,
  },
  b10ButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB10Props(props) ||
      (props.b10ButtonLinkType !== OTHER_LINK_TYPE &&
        props.b10ButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b10ButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB10Props(props) ||
      (props.b10ButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b10ButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b10MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_10].mobileImg,
    description: "Mobile/tablet image (B10 only)",
    hidden: hideB10Props,
  },
  b10DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_10].desktopImg,
    description: "Desktop image (B10 only)",
    hidden: hideB10Props,
  },
  b10ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_10].imageAlt,
    description: "Image alt text (B10 only)",
    hidden: hideB10Props,
  },
};
